(() => {
  const close = dialog => { if (dialog && dialog.open) dialog.close(); };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-newsletter-modal-open]');
    if (opener && !opener.disabled) {
      const dialog = document.getElementById(opener.dataset.newsletterModalOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-newsletter-modal-close]');
    if (closer) close(closer.closest('[data-newsletter-modal]'));
  });
  document.addEventListener('click', event => {
    const dialog = event.target.closest('[data-newsletter-modal]');
    if (dialog && event.target === dialog) close(dialog);
  });
})();
